import './App.css';
import React, {useState} from "react";
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from "./widgets/molecules/header";
import Joueur from "./widgets/atomes/joueur";
import ListeJoueurs from "./widgets/molecules/listeJoueurs";
import JoueurModel from "./models/joueur.js"
import joueursData from "./data/joueurs.json"
import etoilesData from "./data/etoiles.json"
import musiquesData from "./data/musiqueworlds.json"
import evenementsData from "./data/evenements.json"
import MusiqueModel from "./models/musiques";
import ListeMusiques from "./widgets/molecules/listeMusiques";
import Musique from "./widgets/atomes/musique";
import Evenement from "./widgets/atomes/evenement";
import EvenementModel from "./models/evenement";
import ListeEvenement from "./widgets/molecules/listeEvenement";
import BoutonIcon from "./widgets/atomes/boutonIcon";
import GateauIcon from "./widgets/icons/gateau";
import CalendrierIcon from "./widgets/icons/calendrier";
import EvenementPage from "./pages/EvenementPage";
import LCKPage from "./pages/LCKPage";
import LCKRoadToMSIPage from "./pages/LCKRoadToMSIPage";
import MSIPage from "./pages/MSIPage";

function App() {
    const [evenementType, setEvenementType] = useState('tournois');
    const joueurs = joueursData.joueurs.map(j=> JoueurModel.fromJSON(j));
    const joueursTriesParAnniversaire = [...joueurs].sort((a, b) =>
        a.getJoursJusquAnniversaire() - b.getJoursJusquAnniversaire()
    );
    const liens = etoilesData.etoiles.map(e => e.lien);
    const musiques = musiquesData.musiques.map(m => MusiqueModel.fromJSON(m));
    const evenements = evenementsData.evenements.map(ev=> EvenementModel.fromJSON(ev));
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage evenementType={evenementType} setEvenementType={setEvenementType} joueurs={joueurs} joueursTriesParAnniversaire={joueursTriesParAnniversaire} liens={liens} musiques={musiques} evenements={evenements} />} />
                <Route path="/evenement/:titre" element={<EvenementPage />} />
                <Route path="/lck" element={<LCKPage />} />
                <Route path="/lck-road-to-msi" element={<LCKRoadToMSIPage />} />
                <Route path="/msi" element={<MSIPage />} />
            </Routes>
        </Router>
    );
}

function HomePage({ evenementType, setEvenementType, joueurs, joueursTriesParAnniversaire, liens, musiques, evenements }) {
    const [openSection, setOpenSection] = useState('evenements');
    const toggle = (section) => setOpenSection(s => s === section ? null : section);

    return (
        <>
            <div className="bg-image"></div>
            <div className="flex flex-col min-h-screen md:h-screen text-white relative">
                <Header etoiles={liens}/>
                <div className="flex flex-col md:flex-row md:justify-end md:flex-1 md:overflow-hidden">
                        <ListeEvenement
                            titre={evenementType === 'tournois' ? "Événements" : "Anniversaires"}
                            bouton={evenementType === 'tournois' ? <BoutonIcon icon={<GateauIcon/>} onClick={()=>{setEvenementType('anniversaires')}} width={7} height={7} transparent={true}/> : <BoutonIcon icon={<CalendrierIcon/>} onClick={()=>{setEvenementType('tournois')}} width={7} height={7} transparent={true}/>}
                            isOpen={openSection === 'evenements'}
                            onToggle={() => toggle('evenements')}
                        >
                            {evenementType === 'tournois'
                                ? evenements.map((evenement, index) => (
                                    <Evenement key={index} evenement={evenement} />
                                ))
                                : joueursTriesParAnniversaire.map((joueur, index) => (
                                    <Evenement key={index} evenement={joueur} />
                                ))
                            }
                        </ListeEvenement>

                        <ListeJoueurs isOpen={openSection === 'roster'} onToggle={() => toggle('roster')}>
                            {joueurs.map((joueur, index) => (
                                <Joueur key={index} joueur={joueur} />
                            ))}
                        </ListeJoueurs>

                        <ListeMusiques isOpen={openSection === 'musiques'} onToggle={() => toggle('musiques')}>
                            {musiques.map((musique, index) => (
                                <Musique key={index} musique={musique} />
                            ))}
                        </ListeMusiques>
                </div>
            </div>
        </>
    );
}

export default App;